;(function () {
  angular.module('contrast.cve').directive('csCveCount', [csCveCount])

  function csCveCount() {
    return {
      restrict: 'E',
      templateUrl: 'views/cs-cve-count.html',
      controller: 'csCveCountCtrl',
      controllerAs: 'csCveCountCtrl',
      scope: {
        library: '='
      },
      link: function (scope, elem, attrs, ctrl) {
        ctrl.activate({
          library: scope.library
        })
      }
    }
  }
}).call(this)
